import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getRivileStore,
  updateRivileStore,
  clearErrors,
} from "../../redux/Actions/rivileStoreAction";
import RivileStoreEditModal from "./Items/RivileStoreEditModal";
import ContentBlock from "../Layout/ContentBlock";
import TableColumnRivileStore from "./Items/TableColumnRivileStore";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import PaginationComp from "../Dashboard/items/Pagination";

class RivileStoreTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredId: 0,
      page: 1,
      pageCount: 100,
    };
  }
  componentDidMount() {
    this.props.getRivileStore(this.state.page, this.state.pageCount);
  }
  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.props.getRivileStore(this.state.page, this.state.pageCount);
    }
  }

  onAction = (index) => {
    this.setState({
      requiredId: index,
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };

  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  render() {
    const requiredItem = this.state.requiredId;
    let modalData = this.props.rivileStore[requiredItem]
      ? this.props.rivileStore[requiredItem]
      : [];
    return (
      <Container
        location={{
          locationName: "Rivile stores",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            totals={this.props.totals}
            length={this.props.rivileStore.length}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text2="Rivile stores"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox filter={false} add={false}></TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_rivile_store}
              array={this.props.rivileStore}
              alertId_s="rivileAlert-s"
              //   alertId_e="rivileAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-black">
                      <th>#</th>
                      <th>Title</th>
                      <th>City</th>
                      <th>Address</th>
                      <th>Postal code</th>
                      <th>Rivile code</th>
                      <th>Invoice prefix</th>
                      <th>Order prefix</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.rivileStore.map((item, index) => {
                      return (
                        <TableColumnRivileStore
                          key={index}
                          index={index}
                          item={item}
                          onAction={this.onAction}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <PaginationComp
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>

        <RivileStoreEditModal
          objectData={modalData}
          updateRivileStore={this.props.updateRivileStore}
          errors={this.props.errors}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  rivileStore: state.rivileStore.rivile_store,
  totals: state.rivileStore.totals,
  loading_rivileStore: state.rivileStore.loading_rivile_store,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getRivileStore,
  updateRivileStore,
  clearErrors,
})(RivileStoreTemplate);
